import {autoserialize, autoserializeAs} from 'cerialize';
import {FileModel} from './file.model';
export class AttachmentModel {
    @autoserializeAs(FileModel) public file: FileModel;
    @autoserialize public fileName: string;
    @autoserialize public fileExtension: string;
    @autoserialize public fileSize: string;
}
